import React, { useEffect, useState } from 'react';
import './thankupage.scss';
import { userVerification } from '../../actions/userVerification';
import { useDispatch } from 'react-redux';
import { notify } from '../../services/notification';
import { useNavigate } from 'react-router-dom';

const ThankYouPage = () => {

    const [isLoad, setIsLoad] = useState(false);
    const [errorMessage, setErrorMessage] = useState('')
    const [isVerified, setIsVerified] = useState(true)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get('token');

    useEffect(() => {
        if (token) {
            handleUserVerification();
        } else {
            setErrorMessage('No verification token found.');
        }
    }, [token]);

    const handleUserVerification = async () => {
        setIsLoad(true);
        let apiReq = {
            token: token,
        };

        let response = await dispatch(userVerification(apiReq));
        if (response.status === 200) {
            setIsVerified(true)
            notify.success(response.data.message);
            setIsLoad(false);
            window.scroll(0, 0);
        }
        else if (response.status === 400) {
            setIsVerified(false)
            const errorMsg = response?.data?.error;
            setErrorMessage(errorMsg)
        }
        else if (response === undefined) {
            setIsLoad(false)
        }
    };

    const redirectToLogin = () => {
        window.location.href = process.env.REACT_APP_VERIFICATION;
    };
    return (
        <>
            {isVerified ? (
                <div className='verifivation-container'>
                    <div className="thank-you-container">
                        <h1>Your profile has been verified</h1>
                        <p>Please click on link below to login to TRUCHAMP Management Portal</p>
                    </div>
                    <button className='login_btn' onClick={redirectToLogin}>Login</button>
                </div>
            ):(
                <div className="error-container">
                    <h1>Your {errorMessage}. Please contact your area head to access your account.</h1>
                </div>
            )}
        </>
    );
};

export default ThankYouPage;